<template>
  <header-middle />
  <charge-template v-if="mode == 'charge'"/>
  <internet-template v-if="mode == 'internet'"/>
  <!-- <grid-template></grid-template> -->
  <footer-template />
</template>

<script setup>
import HeaderMiddle from '../section/header/header.vue';
// import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
import ChargeTemplate from '../section/pages/Card/ChargeTemplate.vue';
import InternetTemplate from '../section/pages/Card/InternetTemplate.vue';
import { useRoute } from 'vue-router';
import {watch,computed,ref} from 'vue'

let route = useRoute();
let mode = ref();
const page = computed(() => route.query.mode);
watch(page, async () => {
  await setMode()
}, { immediate: true });

async function setMode(){
    mode.value = route.query.mode
}
</script>

<style scoped>

</style>